import script from "./ElencoFasi.vue?vue&type=script&setup=true&lang=js"
export * from "./ElencoFasi.vue?vue&type=script&setup=true&lang=js"

import "./ElencoFasi.vue?vue&type=style&index=0&id=0369be08&lang=css"

const __exports__ = script;

export default __exports__